import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { parseISO } from 'date-fns';
import { formatDate } from '@spa/shared/utils';
import { getMoveInOutByOptionId } from '@spa/shared/utils/contracts';
var START_END_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export var buildPriceDetails = function buildPriceDetails(_ref) {
  var _offer$version;
  var offerAggregate = _ref.offerAggregate,
    query = _ref.query,
    guest = _ref.guest;
  var guests = query.guests,
    optionId = query.optionId;
  var _ref2 = optionId ? getMoveInOutByOptionId(optionId, offerAggregate) : query,
    moveIn = _ref2.moveIn,
    moveOut = _ref2.moveOut;
  var start = moveIn && formatDate(parseISO(moveIn), null, START_END_FORMAT);
  var end = moveOut && formatDate(parseISO(moveOut), null, START_END_FORMAT);
  var offer = offerAggregate.accommodation_offer;
  return _objectSpread(_objectSpread(_objectSpread({
    offer_id: offer.id,
    guests: +guests ? +guests : 1,
    offer_version: (_offer$version = offer.version) !== null && _offer$version !== void 0 ? _offer$version : 0
  }, optionId ? {
    offer_option_id: optionId
  } : {}), start && end ? {
    move_in_out: {
      start: start,
      end: end
    }
  } : {}), guest ? {
    guest_id: guest.id
  } : {});
};